import styled from "styled-components";
import { breakpoints } from "theme/themes";


const StepQuestionText = styled.div`
  font-family: ${({theme}) => theme.fonts.fontMedium };
  font-size: 22px;
  line-height: 1.3;


  @media ${breakpoints.xl} {
    font-size: 24px;
    margin-bottom: 2rem;
  }

  @media ${breakpoints.xl4} {
    font-size: 30px;
  }

  p:not(:last-of-type) {
    margin-bottom: 1rem;
  }

  a {
      text-decoration: underline;
      font-family: ${({ theme }) => theme.fonts.fontHeavy};
      text-decoration-thickness: 3px; 
      text-underline-position: under;
      text-decoration-color: ${({ theme }) => theme.colors.primary};
  }
`;

export default StepQuestionText;
